import axios from 'common/utils/axios';

const activitiesApi = axios('activities');

export const useActivitiesTypes = (params: any) => {
  return activitiesApi.get('types', { params });
};
